import editor from './editor';
import associateEditors from './associateEditors';

export default [...editor, ...associateEditors];